/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Pathfinder API
 * API for all Pathfinder applications.
 * OpenAPI spec version: 1.0.0
 */

export type IndicatorsByMemberListScope = typeof IndicatorsByMemberListScope[keyof typeof IndicatorsByMemberListScope];


export const IndicatorsByMemberListScope = {
  default: 'default',
  engagementnever_activated: 'engagement.never_activated',
  engagementno_first_action: 'engagement.no_first_action',
} as const;
